import { generateNameSuggestionSuffix } from '@bingads-webui-campaign/audience-campaign-shared';

export const GENERIC_ERROR_MESSAGE_KEY = _TL_("We've encountered an error and can't continue. Please contact support for further assistance.");

export const CampaignNegativeReferenceId = -111;

export const WizardScenario = {
  CampaignCreation: 0,
  CampaignEdit: 1,
  AssetGroupCreation: 2,
  AssetGroupEdit: 3,
};

export const getDefaulAudienceGroup = i18n => ({
  Name: generateNameSuggestionSuffix(i18n.getString(_TL_('Windows Store Audience Group'))),
  Id: -100,
});
